<template>
  <b-nav v-if="showNav">
    <b-nav-item-dropdown id="my-nav-dropdown" toggle-class="nav-link-custom">
      <template slot="button-content">
        <i class="fa mr-2 fa-signal text-blue" font-scale="1"></i>
        <span>CMDA</span>
      </template>
      <b-dropdown-item to="/cdma/radreply">
        <i class="fa fa-folder-open text-green" font-scale="1"></i>
        Auth Reply
      </b-dropdown-item>
      <b-dropdown-item to="/cdma/radusergroup">
        <i class="fa fa-folder-open text-yellow" font-scale="1"></i>
        Auth Group
      </b-dropdown-item>
      <b-dropdown-item to="/cdma/radcheck">
        <i class="fa fa-folder-open text-primary" font-scale="1"></i>
        Auth Setup
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>
<script>
import initService from '../../../common/api-services/init-service';

export default {
  name: 'top-cdma-group',
  data() {
    return {

      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],
      showNav:false,
      navPermissions: {
        "authGroup": {
          enable: false,
          role: ["CDMA_ADMIN", "CDMA_EDIT", "CDMA_READ", "Administrator"]
        },
      }
    }
  },

  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) {
          this.navPermissions[item].enable = true;
          this.showNav=true;
        }
      });
    });
  }
}
</script>